export const BBCORDERDEATIL_FILE = 'BBCORDERDEATIL_FILE';
// 更新
export const BBCORDERDEATIL_UPDATE = 'BBCORDERDEATIL_UPDATE';
